import { BuildClass, Do, timer } from '../../universal';
import { React, _ } from '../lib';
import { j2r } from './component-react';
export class J2rButton extends React.Component {
    static timeoutConfirmingMs = 2000;
    confirmingTimer;
    constructor(props) {
        super(props);
        this.state = { confirming: false };
        this.confirmingTimer = undefined;
    }
    render() {
        return (React.createElement("button", { className: BuildClass({
                [this.props.cl ?? '']: true,
                btnStdBorderless: this.props.type === 'borderless',
                btnSubmit2: this.props.type === 'submit',
                btnDelete2: this.props.type === 'delete',
                btnStandard2: ['standard', 'button'].includes(this.props.type ?? ''),
                btnTrans: ['trans-red', 'trans-blue'].includes(this.props.type ?? ''),
                red: this.props.type === 'trans-red',
                blue: this.props.type === 'trans-blue',
                disabled: this.props.disabled ?? false,
                confirming: this.state.confirming,
            }), title: this.props.title ?? this.props.label, type: this.props.type === 'submit' ? 'submit' : 'button', disabled: this.props.disabled ? true : undefined, style: {
                ...(this.props.hidden ? { display: 'none' } : undefined),
                ...this.props.style,
            }, onClick: (e) => {
                if (this.props.doubleClickNeeded) {
                    if (!this.state.confirming) {
                        this.setState({ confirming: true });
                        this.confirmingTimer = timer(J2rButton.timeoutConfirmingMs, () => {
                            this.setState({ confirming: false });
                        });
                        return;
                    }
                    this.setState({ confirming: false });
                    clearTimeout(this.confirmingTimer);
                }
                ;
                (this.props.onClick ?? _.noop)(e);
            } }, Do(() => {
            if (this.state.confirming) {
                return React.createElement("span", null, "Confirm?");
            }
            if (this.props.inner != null) {
                return j2r(this.props.inner);
            }
            return (React.createElement(React.Fragment, null,
                this.props.img != null && React.createElement("img", { src: this.props.img }),
                React.createElement("span", null, this.props.label)));
        })));
    }
}
//# sourceMappingURL=component-buttons.js.map